module.exports = __webpack_public_path__ + "img/post-switzerland-cod-alternate.260894de.png";